var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSportBasketball24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_sport_basketball24x24",
    transform: "translate(1560 234)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45665",
    d: "M-1559.025-227.411c-.089-.089-.177-.089-.355-.089a.885.885,0,0,0-.443.355,6.64,6.64,0,0,0-.177,1.862,9.771,9.771,0,0,0,.177,1.6,10.638,10.638,0,0,1,1.33-3.28A2.35,2.35,0,0,0-1559.025-227.411Z",
    transform: "translate(0 -.717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45666",
    d: "M-1558.5-228.529a2.351,2.351,0,0,1,.532.443,4.872,4.872,0,0,1,.62-.8,9,9,0,0,1-.532-2.216,6.256,6.256,0,0,0-1.418,2.3A1.43,1.43,0,0,1-1558.5-228.529Z",
    transform: "translate(-.079 -.321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45667",
    d: "M-1555.286-230.752v-.443a3.544,3.544,0,0,1,.887-2.3,6.037,6.037,0,0,0-2.3,1.33,5.018,5.018,0,0,0,.266,2.3C-1556.084-230.131-1555.641-230.486-1555.286-230.752Z",
    transform: "translate(-.38 -.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45668",
    d: "M-1548.7-232.848a9.637,9.637,0,0,1,1.6.089,8.255,8.255,0,0,0-4.344-1.241,4.315,4.315,0,0,0-1.064.089,3.725,3.725,0,0,0-1.684,2.571A11.149,11.149,0,0,1-1548.7-232.848Z",
    transform: "translate(-.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45669",
    d: "M-1545.578-231.261A10.051,10.051,0,0,0-1554-230.2c.266,1.152,1.241,1.862,3.191,2.394l1.064.266c2.128.532,4.876,1.241,6.294,3.28a8.737,8.737,0,0,0,.177-1.507A8.536,8.536,0,0,0-1545.578-231.261Z",
    transform: "translate(-.727 -.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45670",
    d: "M-1550.238-226.475l-1.064-.266c-1.507-.443-3.1-1.152-3.635-2.66a10.609,10.609,0,0,0-1.064.975,18.285,18.285,0,0,0,2.926,4.876c3.723,4.876,5.408,4.964,5.762,4.876a8.429,8.429,0,0,0,3.369-4.078C-1545.1-225.056-1547.933-225.854-1550.238-226.475Z",
    transform: "translate(-.5 -.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45671",
    d: "M-1553.92-222.89a24.788,24.788,0,0,1-2.837-4.61c-.177.177-.266.443-.443.621a19.328,19.328,0,0,1,.975,3.9c.62,3.28,1.684,4.964,3.457,5.585a4.316,4.316,0,0,0,1.064.089,7.068,7.068,0,0,0,3.014-.621C-1549.753-218.369-1551.438-219.7-1553.92-222.89Z",
    transform: "translate(-.333 -.695)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45672",
    d: "M-1557.948-225.8a9.775,9.775,0,0,0-1.153,4.167,8.4,8.4,0,0,0,3.723,3.723,11.382,11.382,0,0,1-1.862-4.7A28.443,28.443,0,0,0-1557.948-225.8Z",
    transform: "translate(-.102 -.888)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSportBasketball24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_sport_basketball24x24.98ec2652eb1b9ab193a98bfd27a964b8.svg";